import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {getCategories} from "../../store/reducers/CategoriesSlice";
import {CategoriesTable} from "./components/CategoriesTable";

interface CategoriesTableProps {
}

export const CategoriesScreen: React.FC<CategoriesTableProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getCategories());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Grupid</h1>
            <CategoriesTable />
        </LoggedInView>
    )

}